import { AnimationBuilder, AnimationPlayer } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';
import { HEADER_TOP_MENU, LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ApplicationConfig } from '../../config/config';
import { FlyoutFeedComponent } from '../../flyout/flyout-feed/flyout-feed.component';
import { AdobeDataLayerService } from '../../services/adobe-data-layer/adobe-data-layer';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';

@Component({
  selector: 'ngc-notification',
  templateUrl: 'notification.component.html'
})
export class NotificationComponent implements OnInit, OnDestroy {
  @ViewChild('triggerElement') triggerElement: ElementRef;
  bsModalRef: BsModalRef;
  config = {
    animated: false,
    ignoreBackdropClick: true,
    keyboard: false
  };

  public feedCounterValue = 0;
  public feedNotificationObj = {
    feedCounterValue: 0,
    lastVisitedFeedAdvisories: null,
    lastVisitedFeedExpiry: null
  };

  public timeouts = [];
  public player: AnimationPlayer;
  @Input() isAlertAdvisory: boolean;
  @Input() businessUser;
  @Output() modalServiceRef = new EventEmitter<any>();
  contentHeaderFooterServiceSubscribe: Subscription;
  modalServiceOnHiddenSubscribe: Subscription;
  private animationTime = '300ms';
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private http: HttpClient,
    private _el: ElementRef,
    private renderer: Renderer2,
    private modalService: BsModalService,
    private changeDetection: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    private _config: ApplicationConfig,
    private cookieHelper: CookieHelper,
    private datalayer: DataLayer,
    private _builder: AnimationBuilder,
    private loggingService: LoggingService,
    private srv: CommonService,
    private adobeDataLayer: AdobeDataLayerService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.getFeedData();
  }

  getFeedData() {
    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (this.contentService.contentHeaderFooter) {
            this.contentHeaderFooterServiceSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (data) => {
                    const dataAEMHeaderFooter = data;
                    if (dataAEMHeaderFooter && dataAEMHeaderFooter.advisories) {
                      if (dataAEMHeaderFooter.advisories.advisoriesList) {
                        const storedFeedNotificationObj = JSON.parse(
                          localStorage.getItem('feedNotificationObj')
                        );
                        if (storedFeedNotificationObj) {
                          this.feedNotificationObj = storedFeedNotificationObj;
                        }
                        const currentDate = this.extractDate(
                          new Date().toISOString()
                        );
                        if (this.feedNotificationObj.lastVisitedFeedExpiry) {
                          const feedExpiryDate = this.extractDate(
                            this.feedNotificationObj.lastVisitedFeedExpiry
                          );
                          if (currentDate === feedExpiryDate) {
                            this.feedNotificationObj.lastVisitedFeedAdvisories =
                              null;
                            this.feedNotificationObj.lastVisitedFeedExpiry =
                              null;
                          }
                        }
                        if (
                          this.feedNotificationObj.lastVisitedFeedAdvisories
                        ) {
                          const getFeedLength: any =
                            dataAEMHeaderFooter.advisories.advisoriesList
                              .length > 3
                              ? 3
                              : dataAEMHeaderFooter.advisories.advisoriesList
                                  .length;
                          for (let i = 0; i < getFeedLength; i++) {
                            const feedDate =
                              dataAEMHeaderFooter.advisories.advisoriesList[i]
                                .timestamp;
                            const newMonthAsNumber: any =
                              'JanFebMarAprMayJunJulAugSepOctNovDec'.indexOf(
                                feedDate.substr(0, 3)
                              ) / 3;
                            const dateString: string =
                              feedDate
                                .substr(feedDate.indexOf(',') + 2, 4)
                                .toString() +
                              '-' +
                              newMonthAsNumber.toString() +
                              '-' +
                              feedDate
                                .substring(4, feedDate.indexOf(','))
                                .toString();
                            const newDate: any = new Date(dateString);
                            const cookieDate: any = new Date(
                              this.feedNotificationObj.lastVisitedFeedAdvisories
                            );
                            if (newDate > cookieDate) {
                              this.feedCounterValue = this.feedCounterValue + 1;
                            }
                          }
                        } else {
                          if (
                            dataAEMHeaderFooter.advisories.advisoriesList
                              .length > 3
                          ) {
                            this.feedCounterValue = 3;
                          } else {
                            this.feedCounterValue =
                              dataAEMHeaderFooter.advisories.advisoriesList.length;
                          }
                        }
                      } else {
                        this.feedCounterValue = 0;
                      }
                      this.feedNotificationObj.feedCounterValue =
                        this.feedCounterValue;
                      localStorage.setItem(
                        'feedNotificationObj',
                        JSON.stringify(this.feedNotificationObj)
                      );
                    }
                  },
                  (err) => {
                    this.loggingService.log('Caught Error: ' + err);
                  }
                );
          }
        }
      });
  }

  extractDate(dateVal) {
    const extractedDate = dateVal.split('T')[0];
    return extractedDate;
  }

  open() {
    try {
      const bodyScroll = document.documentElement.scrollTop;
      this.feedCounterValue = 0;
      const visitedTodayDate: Date = new Date();
      const setFeedExpiryDate: Date = new Date();
      setFeedExpiryDate.setFullYear(setFeedExpiryDate.getFullYear() + 1);
      this.feedNotificationObj.lastVisitedFeedAdvisories = visitedTodayDate;
      this.feedNotificationObj.lastVisitedFeedExpiry = setFeedExpiryDate;
      this.feedNotificationObj.feedCounterValue = this.feedCounterValue;
      localStorage.setItem(
        'feedNotificationObj',
        JSON.stringify(this.feedNotificationObj)
      );
      let obj;
      if (this.isAlertAdvisory) {
        obj = Object.assign({}, this.config, {
          class:
            'loggedIn-modal-dialog loggedIn-alertAdv-modal-dialog no-transform'
        });
      } else {
        obj = Object.assign({}, this.config, {
          class: 'loggedIn-modal-dialog no-transform'
        });
      }

      this.bsModalRef = this.modalService.show(FlyoutFeedComponent, obj);

      const htmlRoot = document.getElementsByTagName('html')[0];
      if (!(htmlRoot.className.indexOf('no-scroll') >= 0)) {
        htmlRoot.className += ' no-scroll';
      }
      this.modalServiceOnHiddenSubscribe = this.modalService.onHidden
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (reason: string) => {
            this.triggerElement.nativeElement.focus();
            this.modalServiceRef.emit(null);
          },
          (err) => {
            this.loggingService.log('Caught Error: ' + err);
          }
        );
      this.srv.dragModalContainers(this._el, this.renderer);
      document.documentElement.scrollTop = bodyScroll;

      this.animateNotificationModal();

      this.srv.focusModalContainers(this._el, this.renderer);
    } catch (err) {
      this.loggingService.log('Caught Error: ' + err);
    }
  }

  setTrackingObj(e) {
    this.datalayer.setTrackingObjectProp1('header:feed', e.target);

    this.adobeDataLayer.updateAnalytics(
      'notification',
      HEADER_TOP_MENU.NOTIFICATION
    );
  }

  stopTimeout() {
    for (let i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i]);
    }
    this.timeouts = [];
  }

  ngOnDestroy() {
    if (this.contentHeaderFooterServiceSubscribe) {
      this.contentHeaderFooterServiceSubscribe.unsubscribe();
    }
    if (this.modalServiceOnHiddenSubscribe) {
      this.modalServiceOnHiddenSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.stopTimeout();
    this.modalServiceRef.emit(null);
  }

  animateLoggedInNotificationModal() {
    if (this.bsModalRef && isPlatformBrowser(this.platformId)) {
      if (document.body.scrollWidth > 992) {
        this.setParentContainerClass();
        this.bsModalRef.content.loggedInModalLoaded = true;
        document
          .getElementsByTagName('modal-container')[0]
          .classList.add('notification-loggedin-modal');
        this.modalServiceRef.emit(this.bsModalRef);
      } else {
        this.bsModalRef.content.isFlyoutLoaded = true;
        const feedHeaders = document.getElementsByClassName('feed-header');
        if (feedHeaders !== undefined && feedHeaders !== null) {
          for (let i = 0; i < feedHeaders.length; i++) {
            document
              .getElementsByClassName('feed-header')
              [i].classList.add('feed-header-fixed');
          }
        }
        this.setParentContainerClass();
      }
    }
  }

  animateNotificationModal() {
    if (this.bsModalRef && isPlatformBrowser(this.platformId)) {
      if (document.body.scrollWidth > 992) {
        this.setParentContainerClass();
        this.bsModalRef.content.notificationModalLoaded = true;
        document
          .getElementsByTagName('modal-container')[0]
          .classList.add('notification-header-modal');
        this.bsModalRef.content.dialog.nativeElement.focus();
        this.modalServiceRef.emit(this.bsModalRef);
      } else if (document.body.scrollWidth > 767) {
        this.setParentContainerClass();
        this.bsModalRef.content.notificationModalLoaded = true;
        document
          .getElementsByTagName('modal-container')[0]
          .classList.add('notification-header-modal');
      } else {
        this.bsModalRef.content.isFlyoutLoaded = true;
        document
          .getElementsByClassName('feed-header')[0]
          .classList.add('feed-header-fixed');
        document
          .getElementsByClassName('mobile-view-all')[0]
          .classList.remove('mobile-view-all-absolute');
        this.setParentContainerClass();
      }
    }
  }

  setParentContainerClass() {
    this.bsModalRef.content.dialog.nativeElement
      .querySelector('div.tab-content')
      .setAttribute('tabIndex', '-1');
    const parentContainer =
      this.bsModalRef.content.dialog.nativeElement.offsetParent;
    if (parentContainer !== null) {
      parentContainer.children[0].className += ' loggedIn-modal-height';
    }
  }
}
